<div class="scrollable-wrapper">
  <edit-company
    *ngIf="!!formGroup && !!organization"
    [formGroup]="formGroup"
    [isEditView]="true"
    [organization]="organization"
    [company]="company"
    [isPayPalPaymentTokenLoading]="isPayPalPaymentTokenLoading"
    (resetFormSource$)="revertFormToInitialState()"
    (updateCompanySource$)="onCompanyUpdated()"
    (deletePayment)="onRemoveMonthlyPayment($event)"
    (deleteCompanySource$)="onShowDeleteConfirm()"
    (paypalPaymentToken)="onPaypalPaymentToken()"
  ></edit-company>
</div>

<delete-company-modal
  [isOpen]="isDeleteModalOpen"
  [company]="company"
  [isDeleting]="isDeletingCompany"
  [headerKey]="'DELETE_IOR_PROFILE'"
  [descriptionKey]="'DELETE_IOR_DESCRIPTION'"
  [confirmButtonKey]="'BUTTON.DELETE_IOR'"
  [fallbackNameKey]="'LABELS.IMPORTER_OF_RECORD'"
  (confirmed)="onDeleteCompany()"
  (cancelled)="onHideDeleteConfirm()"
></delete-company-modal>
